import React, { useCallback, useEffect, useState } from 'react';

export function useResolvedPortalBrandingLogo(
  remoteLogo: { url: string; name: string } | null | undefined,
): { src: string | null; onImgError: () => void } {
  const remoteUrl = remoteLogo?.url?.trim() || null;
  const [remoteFailed, setRemoteFailed] = useState(false);

  useEffect(() => {
    setRemoteFailed(false);
  }, [remoteUrl]);

  const src = remoteUrl && !remoteFailed ? remoteUrl : null;
  const onImgError = useCallback(() => {
    setRemoteFailed(true);
  }, []);

  return { src, onImgError };
}

type TradeBriefingChromeProps = {
  backgroundUrl: string | null;
  logoSrc: string | null;
  onLogoError: () => void;
  children: React.ReactNode;
};

const TradeBriefingChrome: React.FC<TradeBriefingChromeProps> = ({
  backgroundUrl,
  logoSrc,
  onLogoError,
  children,
}) => {
  return (
    <div className="tb-page">
      <header className="tb-site-header">
        {backgroundUrl ? (
          <div className="tb-site-header-media" style={{ backgroundImage: `url(${backgroundUrl})` }} />
        ) : null}
        <div className="tb-site-header-veil" />
        <div className="tb-site-header-inner">
          {logoSrc ? (
            <img src={logoSrc} alt="Leiper's Creek Timber Frames" onError={onLogoError} />
          ) : (
            <p className="tb-wordmark">
              Leiper&apos;s Creek
              <span>Timber Frames</span>
            </p>
          )}
        </div>
      </header>
      <div className="tb-page-body">{children}</div>
    </div>
  );
};

export default TradeBriefingChrome;
